import { render, staticRenderFns } from "./CmgLoyaltyBannerHomepage.vue?vue&type=template&id=39b282aa&scoped=true&lang=pug&"
import script from "./cmg-loyalty-banner-homepage.ts?vue&type=script&lang=ts&"
export * from "./cmg-loyalty-banner-homepage.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLoyaltyBannerHomepage.vue?vue&type=style&index=0&id=39b282aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b282aa",
  null
  
)

export default component.exports